/*eslint-disable */
const Q = require('q');
/**
 * 动态添加js
 * @param url
 * @returns {*}
 */
export function loadJs(url) {
	return Q.Promise((resolve, reject) => {
		let srcArr = document.getElementsByTagName("script");
		let hasLoaded = false;
		//判断当前js是否加载上
		for (let i = 0; i < srcArr.length; i++) {
			hasLoaded = (srcArr[i].src === url);
			if (hasLoaded) {
				break;
			}
		}
		if (hasLoaded) {
			resolve();
			return;
		}
		let script = document.createElement('script')
		script.type = 'text/javascript';
		script.src = url;
		document.head.appendChild(script);
		script.onload = () => {
			resolve();
		}
		script.onerror = () => {
			reject();
		}
	})
}

/**
 * 动态添加css
 * @param url
 */
export function loadCss(url) {
	let css = document.createElement('link');
	css.href = url;
	css.rel = 'stylesheet';
	css.type = 'text/css';
	document.head.appendChild(css);
}